import type { Nil } from "cy-util";

export const urls = {
  home: createNode({ href: "/home", name: "Home" }),
  loggedOut: createNode({ href: "/", name: "Logged out" }),
  signin: createNode({ href: "/public/signin", name: "Signin" }),
  completeRegistration: {
    href: "/complete-registration",
    address: createNode({
      href: "/complete-registration/address",
      name: "Complete address",
    }),
    identification: createNode({
      href: "/complete-registration/identification",
      name: "Complete identification",
    }),
    documents: createNode({
      href: "/complete-registration/documents",
      name: "Complete documents",
    }),
  },
  register: {
    start: createNode({
      href: "/public/register?step=start",
      name: "Register",
    }),
    country: createNode({
      href: "/public/register?step=country",
      name: "Country",
    }),
    identification: createNode({
      href: "/public/register?step=identification",
      name: "Identification",
    }),
    createAccount: createNode({
      href: "/public/register?step=createAccount",
      name: "Country",
    }),
    accountType: createNode({
      href: "/public/register?step=accountType",
      name: "Account Type",
    }),
    accountLimit: createNode({
      href: "/public/register?step=accountLimit",
      name: "Account Limit",
    }),
    mobile: createNode({
      href: "/public/register?step=mobile",
      name: "Mobile",
    }),
    otp: createNode({ href: "/public/register?step=otp", name: "Otp" }),
    personal: createNode({
      href: "/public/register?step=personal",
      name: "Personal information",
    }),
    marketing: createNode({
      href: "/public/register?step=marketing",
      name: "Marketing Information",
    }),
    address: createNode({
      href: "/public/register?step=address",
      name: "Residence information",
    }),
    password: createNode({
      href: "/public/register?step=password",
      name: "Create Password",
    }),
    done: createNode({
      href: "/public/register?step=done",
      name: "Registration Completed",
    }),
  },
  editPersonalDetails: {
    href: "/edit-personal-details",
  },
  editContactDetails: {
    href: "/edit-contact-details",
  },
  transactions: {
    href: "/transactions",
    name: "Transactions",
    isCurrent(path: string | Nil) {
      return isCurrent(path, this.href);
    },
    transaction(id: number) {
      return { href: `${this.href}/${id}` };
    },
  },
  uploadDocuments: {
    href: "/upload-documents",
  },
  settings: {
    href: "/settings",
    profile() {
      return {
        href: `${this.href}/profile`,
      };
    },
    limits() {
      return {
        href: `${this.href}/limits`,
      };
    },
  },
  beneficiaries: {
    href: "/beneficiaries",
    isCurrent(path: string | Nil) {
      return isCurrent(path, this.href);
    },
    beneficiary(id: number) {
      return {
        href: `${this.href}/${id}`,
        edit: {
          href: `${this.href}/${id}/edit`,
        },
      };
    },
  },
  account: createNode({ href: "/account", name: "Account" }),
  payment(transactionId: number) {
    return {
      href: `/payment/${transactionId}`,
      peach: {
        href: `/payment/${transactionId}/peach`,
        callback: {
          href: `/api/public/peach/notify`,
        },
        error: {
          href: `/payment/${transactionId}/peach/error`,
        },
      },
      ozow: {
        href: `/payment/${transactionId}/ozow`,
      },
      payAt: {
        href: `/payment/${transactionId}/pay-at`,
      },
      complete: {
        settled: {
          href: `/payment/${transactionId}/complete/settled`,
        },
        unpaid: {
          href: `/payment/${transactionId}/complete/unpaid`,
        },
      },
    };
  },
  sendMoney: {
    start: createNode({
      href: "/send-money?step=start",
      name: "Send Money",
    }),
    transaction: createNode({
      href: "/send-money?step=transaction",
      name: "Send Money",
    }),
    beneficiary: createNode({
      href: "/send-money?step=recipient",
      name: "Send Money - Recipient",
    }),
    review: createNode({
      href: "/send-money?step=review",
      name: "Send Money - Review",
    }),
  },
};

function isCurrent(path: string | Nil, href: string) {
  return (path || "").toLowerCase().startsWith(href.toLowerCase());
}

function createNode({ href, name }: { href: string; name: string }) {
  return {
    href,
    name,
    isCurrent: (path: string | Nil) =>
      (path || "").toLowerCase().startsWith(href.toLowerCase()),
  };
}
